import "./style.css";
import { h } from "./reactive-element-DZ4uc4cT-BmQGLYME-HcXnJBgK-C5QAKziK.js";
import { render as ie, noChange as N } from "./index-CYA3oVVY-hqmzhX60-DijabQOP.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class r extends h {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e;
    const t = super.createRenderRoot();
    return (e = this.renderOptions).renderBefore != null || (e.renderBefore = t.firstChild), t;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = ie(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) == null || e.setConnected(true);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) == null || e.setConnected(false);
  }
  render() {
    return N;
  }
}
var s;
r._$litElement$ = true, r.finalized = true, (s = globalThis.litElementHydrateSupport) == null || s.call(globalThis, { LitElement: r });
const l = globalThis.litElementPolyfillSupport;
l == null || l({ LitElement: r });
const u = { _$AK: (n, e, t) => {
  n._$AK(e, t);
}, _$AL: (n) => n._$AL };
var o;
((o = globalThis.litElementVersions) != null ? o : globalThis.litElementVersions = []).push("4.1.1");
export {
  r,
  u
};
